const EventEmitter = require('events');

const eventBus = new EventEmitter();
export default eventBus;
